import axios from 'axios'
import router from "../router";
import { mapGetters } from 'vuex';

export const activity = {
  namespaced: true,
  state: () => ({
    isLoading: false,
    isUpdated: false,

    /* 活動資訊 */
    event_id: null,
    routeActivityId: '',
    basic_info: {},
    announcement_info: {},
    ticket_info: {},
    venue_info: {},
    matter_content: {},
    lottery_info: {},
    recommendList: [],

    /* 購票 */
    // 是否已同意限制級活動
    is_r18_agree: false,
    /* 身障區域 */
    disability: false,
    // 場次
    session_name: '',
    //購票限制
    ticket_limit: 1,
    // 區域
    area_id: '',
    area_name: '',
    seating_area: '',
    ticket_type_info: [],
    // 票種
    selectedTicketName: '',
    ticket_number: 1,
    // 依照購票流程才可瀏覽下一步，禁止直接輸入網址
    show_page: false,
    // 購票倒數計時
    order_countdown: "10:00",
    countdown_timer: null,
    // 最終確認的座位（無論是電腦配位還是自選）
    confirmedSeats: [],
    // 取票方式 (T-KI 或 3Q PASS)
    is_3qpass: false,
    // reCAPTCHA token
    recaptchaToken: '',
    purchaseSerialCodes: [],
    /* 優先購 */
    verifiedBin: null,
    priorityPurchaseRules: [],
    /* 訂單 */
    orderData: {},
    /* 退票申請 */
    refund_item: {}
  }),
  computed: {
    ...mapGetters('user', ['getLoginData'])
  },
  mutations: {
    getEventData(state, data) {
      state.basic_info = data.basic_info;
      state.announcement_info = data.announcement_info;
      state.ticket_info = data.ticket_info;
      state.venue_info = data.venue_info;
      state.matter_content = data.matter_content;
      state.lottery_info = data.lottery_info;
    },
    clearData(state) {
      state.basic_info = {};
      state.announcement_info = {};
      state.ticket_info = {};
      state.venue_info = {};
      state.matter_content = {};
      state.lottery_info = {};
      state.event_id = null;
    },
    getRecommendList(state, data) {
      state.recommendList = data;
    },
    minus(state) {
      state.ticket_number--;
    },
    plus(state) {
      state.ticket_number++;
    },
    setTicketData(state, { stateData, data }) {
      state[stateData] = data;
    },
    setOrderCart(state, data) {
      state.orderData.cart_details = data;
    },
    setRefundItem(state, data) {
      state.refund_item = data;
    },
    setR18Agree(state, data) {
      state.is_r18_agree = data;
    },
    setConfirmedSeats(state, data) {
      state.confirmedSeats = data;
    },
    updateCountdown(state, time) {
      state.order_countdown = time;
    },
    setCountdownTimer(state, timer) {
      state.countdown_timer = timer;
    },
    clearCountdownTimer(state) {
      if (state.countdown_timer) {
        // 如果是 Web Worker 實例，需要先發送停止命令並終止
        if (state.countdown_timer instanceof Worker) {
          state.countdown_timer.postMessage({ command: 'stop' });
          state.countdown_timer.terminate();
        } else {
          // 傳統計時器的清理邏輯
          clearInterval(state.countdown_timer);
        }
        state.countdown_timer = null;
      }
      state.order_countdown = "10:00";
    },
    // 新增：清除活動選擇相關的 state
    clearActivityChoices(state) {
      state.is_r18_agree = false;
      state.disability = false;
      state.session_name = '';
      state.ticket_limit = 1; // 重設為預設值 1
      state.area_id = '';
      state.area_name = '';
      state.seating_area = '';
      state.ticket_type_info = [];
      state.selectedTicketName = '';
      state.ticket_number = 1;
      state.show_page = false;
      state.selectedSeats = [];
      state.confirmedSeats = [];
      state.is_3qpass = false;
      state.recaptchaToken = '';
      state.purchaseSerialCodes = [];
      state.verifiedBin = null;
      state.orderData = {};
      state.refund_item = {};
    },
    setIs3qpass(state, data) {
      state.is_3qpass = data;
    },
    setRecaptchaToken(state, token) {
      state.recaptchaToken = token;
    },
    setVerifiedBin(state, bin) {
      state.verifiedBin = bin;
    },
    setPriorityPurchaseRules(state, rules) {
      state.priorityPurchaseRules = rules;
    }
  },
  actions: {
    /* 取得活動資訊，T-KI、街聲會員帶Token，其他不帶Token*/
    getData({ commit, rootGetters }, { eventId, code }) {
      console.log('code', code);
      commit('setTicketData', { stateData: 'isLoading', data: true });
      commit('clearData');
      commit('clearActivityChoices');
      commit('clearCountdownTimer');
      commit('setTicketData', { stateData: 'isUpdated', data: false });
      
      let apiUrl = `${process.env.VUE_APP_PATH}/event/get-info?event_id=${eventId}`;
      // 如果有 code 參數，則添加到 API URL
      if (code) {
        apiUrl += `&code=${code}`;
      }
      
      const accessToken = rootGetters['user/getLoginData'] ? rootGetters['user/getLoginData'].access_token : null;
      const headers = accessToken ? {
        'Authorization': `Bearer ${accessToken}`
      } : {};

      axios.get(apiUrl, { headers })
        .then(res => {
          if (res.data.status_code === 'SYSTEM_1000') {
            commit('getEventData', res.data.data);
            if (res.data.data.ticket_info && res.data.data.ticket_info.priority_purchase_rules) {
              commit('setPriorityPurchaseRules', res.data.data.ticket_info.priority_purchase_rules);
            }
            commit('setTicketData', { stateData: 'isUpdated', data: true });
            commit('setTicketData', { stateData: 'isLoading', data: false });
          } else {
            // T-KI 無限偶像祭，一次性活動，之後刪除
            const route1 = '/activity/detail/tkiidolfestival-2/buy-ticket/session';
            const route2 = '/activity/detail/tkiidolfestival-3/buy-ticket/session';
            const route3 = '/activity/detail/tkiidolfestival-4/buy-ticket/session';

            switch (router.currentRoute.value.path) {
              case route1:
                router.push(route2);
                break;
              case route2:
                router.push(route3);
                break;
              default:
                router.push('/404');
            }

            commit('setTicketData', { stateData: 'isLoading', data: false });
          }
        })
        .catch(error => {
          console.error('error occurred:', error);
        });
    },
    getDraft({ commit }, identifier) {
      commit('clearData');
      commit('clearActivityChoices'); // 清除舊活動選擇
      commit('clearCountdownTimer'); // 清除並重設計時器
      commit('setTicketData', { stateData: 'isUpdated', data: false });
      axios.get(`${process.env.VUE_APP_PATH}/event/get-draft-info?identifier=${identifier}`)
        .then(res => {
          if (res.data.status_code === 'SYSTEM_1000') {
            commit('getData', res.data.data);
            commit('setTicketData', { stateData: 'isUpdated', data: true });
            commit('setTicketData', { stateData: 'isLoading', data: false });
          } else {
            commit('setTicketData', { stateData: 'isLoading', data: false });
            router.push('/404');
          }
        });
    },
    /* 為您推薦 */
    getRecommendList({ commit }, eventId) {
      let apiUrl = `${process.env.VUE_APP_PATH}/event/get-recommend-list`;
      if (eventId) {
        apiUrl += `?event_id=${eventId}`;
      }

      axios.get(apiUrl)
        .then(res => {
          if (res.data.status_code === 'SYSTEM_1000') {
            commit('getRecommendList', res.data.data);
          } else {
            console.error('error');
          }
        })
        .catch(error => {
          console.error('error occurred:', error);
        });
    },
    //訂單倒計時
    startCountdown({ commit, state }) {
      // 清除現有的計時器
      commit('clearCountdownTimer');

      try {
        // 使用 Blob URL 方式創建 Worker
        const workerScript = `
          let timerId = null;
          let startTime = null;
          let totalDuration = 0;

          self.onmessage = function(e) {
            const command = e.data.command;

            if (command === 'start') {
              totalDuration = e.data.duration || (10 * 60); // 預設10分鐘
              startTime = Date.now();
              
              // 清除舊的計時器
              if (timerId) {
                clearInterval(timerId);
              }
              
              // 啟動新計時器，每秒執行一次
              timerId = setInterval(() => {
                const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
                const remainingSeconds = totalDuration - elapsedSeconds;
                
                if (remainingSeconds <= 0) {
                  clearInterval(timerId);
                  self.postMessage({ timeString: "00:00", completed: true });
                  return;
                }
                
                // 格式化時間
                const minutes = Math.floor(remainingSeconds / 60);
                const seconds = remainingSeconds % 60;
                const timeString = \`\${minutes.toString().padStart(2, '0')}:\${seconds.toString().padStart(2, '0')}\`;
                
                self.postMessage({ timeString, completed: false });
              }, 100); // 設置更頻繁的檢查，提高精確度
            } else if (command === 'stop') {
              if (timerId) {
                clearInterval(timerId);
                timerId = null;
              }
            }
          };
        `;
        
        const blob = new Blob([workerScript], { type: 'application/javascript' });
        const worker = new Worker(URL.createObjectURL(blob));
        
        // 啟動倒計時，設置10分鐘
        worker.postMessage({ command: 'start', duration: 10 * 60 });
        
        // 監聽 Worker 發送的消息
        worker.onmessage = (e) => {
          commit('updateCountdown', e.data.timeString);
          
          // 如果倒計時完成，清理 Worker
          if (e.data.completed) {
            worker.terminate();
            commit('setCountdownTimer', null);
          }
        };
        
        // 將 worker 存入 state
        commit('setCountdownTimer', worker);
      } catch (error) {
        console.error('Web Worker 初始化失敗，使用傳統計時器作為備用', error);
        
        // 作為備用的傳統計時器邏輯
        let totalSeconds = 10 * 60;
        
        const timer = setInterval(() => {
          totalSeconds -= 1;

          if (totalSeconds <= 0) {
            // 清除計時器
            clearInterval(timer);
            // 更新時間為 00:00
            commit('updateCountdown', "00:00");
            commit('setCountdownTimer', null);
            return;
          }

          // 更新時間格式
          const minutes = Math.floor(totalSeconds / 60);
          const seconds = totalSeconds % 60;
          const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

          commit('updateCountdown', timeString);
        }, 1000);

        // 將計時器存入 state
        commit('setCountdownTimer', timer);
      }
    },
    async handleCancelOrder({ commit, state, rootGetters }) {
      const orderId = state.orderData.order_id;
      // 如果訂單還未產生，則不 call api
      if (!orderId) {
        return;
      }
      const apiUrl = `${process.env.VUE_APP_PATH}/order/cancel`;

      try {
        const res = await axios.post(apiUrl, { order_id: orderId }, {
          headers: {
            'Authorization': `Bearer ${rootGetters['user/getLoginData'].access_token}`,
          }
        });
      } catch (error) {
        console.error('Failed to cancel order:', error);
        // 可以在這裡添加錯誤處理邏輯
      }
    },
    // 購票
    async buyTicket({ commit, state, rootGetters, getters }) {
      let apiUrl;
      const ticketPrice = getters.ticketPrice;
      const totalAmount = ticketPrice * state.ticket_number;

      apiUrl = totalAmount === 0
        ? `${process.env.VUE_APP_PATH}/event/buy-free-ticket-web`
        : `${process.env.VUE_APP_PATH}/event/buy-ticket-web`;

      commit('setTicketData', { stateData: 'isLoading', data: true });

      // 從 confirmedSeats 中獲取座位IDs
      const seatIds = state.confirmedSeats.map(seat => seat.id);

      try {
        const res = await axios.post(apiUrl,
          {
            type_id: state.ticket_type_info.find(ticket => ticket.ticket_name === state.selectedTicketName)?.ticket_id,
            ticket_number: state.ticket_number,
            recaptcha_token: state.recaptchaToken,
            is_3qpass: state.is_3qpass,
            seat_ids: seatIds,
            card_bin: state.verifiedBin,
            serial_codes: state.purchaseSerialCodes
          },
          {
            headers: {
              'Authorization': `Bearer ${rootGetters['user/getLoginData'].access_token}`,
            }
          });

        commit('setTicketData', { stateData: 'isLoading', data: false });

        // 回傳結果，供元件處理後續邏輯
        return res.data;

      } catch (error) {
        commit('setTicketData', { stateData: 'isLoading', data: false });
        console.error('error occurred:', error);
        return { status_code: 'SYSTEM_1005' };
      }
    },

    // 生成 reCAPTCHA token
    async generateRecaptchaToken({ commit }, vueInstance) {
      try {
        await vueInstance.$recaptchaLoaded();
        const token = await vueInstance.$recaptcha('validate');
        commit('setRecaptchaToken', token);
        return token;
      } catch (error) {
        console.error('Failed to generate reCAPTCHA token:', error);
        return null;
      }
    }
  },
  getters: {
    ticketPrice(state) {
      const selectedTicket = state.ticket_type_info.find(ticket => ticket.ticket_name === state.selectedTicketName);
      return selectedTicket ? selectedTicket.ticket_price : '';
    },
    ticket_id(state) {
      const selectedTicket = state.ticket_type_info.find(ticket => ticket.ticket_name === state.selectedTicketName);
      return selectedTicket ? selectedTicket.ticket_id : '';
    }
  }
}
